// extracted by mini-css-extract-plugin
module.exports = {"name":"Card_name__3uyDM","tag":"Card_tag__23mp-","cards":"Card_cards__2dNBN"};